import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expedientes-medicos',
  templateUrl: './expedientes-medicos.component.html',
  styleUrls: ['./expedientes-medicos.component.scss']
})
export class ExpedientesMedicosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
